import React from "react";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelCircleRoundedIcon from "@mui/icons-material/CancelRounded";

const WorkingStatusNew = ({ status }) => {
  return status ? (
    <CheckCircleRoundedIcon fontSize="small" style={{ color: "#28a745" }} />
  ) : (
    <CancelCircleRoundedIcon fontSize="small" style={{ color: "tomato" }} />
  );
};

export default WorkingStatusNew;
